import {getNoticeListRequest} from '@/assets/request/HomeRequest';
import {Message} from "element-ui";
import {showLoading, hideLoading} from '@/js/loading';
export default {
    state:{
        list:[],
    },
    mutations:{
        loadListMutation(state,{list}){
            state.list = list;
        },
    },
    actions:{
        async loadListAction({commit}, params){
          const {
            callback
          } = toString.call(params)==='[object Object]'?params: {};
            showLoading();
            const list = await getNoticeListRequest().catch(r=>{
                const message = '获取首页列表异常';
                Message.error(message);
                console.trace({
                    message,r
                });
                hideLoading();
            });
            if(list.status!==200) {
                hideLoading();
                return Message.warning(list.statusText);
            }
            const { data } = list;
            commit('loadListMutation',{list:data});
            hideLoading();
            toString.call(callback)==='[object Function]' && callback(data)
        },
    },
    getters:{
        homeNoticeGetter(state){return state.list;}
    },
}